import { useCallback } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { PRESERVE_DATE_RANGE_ROUTES } from "../../../constants/routes"

export const usePreserveDateRangeNavigation = (dest: string, handleItemClick?: () => void) => {
    const navigate = useNavigate()
    const location = useLocation()

    const handleClick = useCallback(() => {
        if (handleItemClick) {
            handleItemClick()
            return
        }

        const params = new URLSearchParams(location.search)
        const start = params.get("start")
        const end = params.get("end")

        const toHasDateRange = PRESERVE_DATE_RANGE_ROUTES.some((p) => dest.startsWith(p))

        if (toHasDateRange && start && end) {
            navigate(`${dest}?start=${start}&end=${end}`)
        } else {
            navigate(dest)
        }
    }, [handleItemClick, navigate, dest, location.search, PRESERVE_DATE_RANGE_ROUTES])

    return { handleClick }
}
